import ShareModal from '~/javascripts/components/ShareModal';
import t from '~/javascripts/utils/translation';

const CampaignCreatedModal = ({ campaignUrl, shareModalContentfulContent }) => {
  const footerContent = () => (
    <a
      className='text-cw-black p40 font-normal'
      onClick={() => window.modal.instances['#campaign-created-modal'].toggle()}
    >
      Or do this later and view your fundraiser
    </a>
  );

  return (
    <ShareModal
      defaultSocialShareContent={shareModalContentfulContent}
      footerContent={footerContent()}
      headerText={t('views.campaign_form.campaign_created.header')}
      modalId='campaign-created-modal'
      shareUrl={campaignUrl}
      subheaderText={t('views.campaign_form.campaign_created.intro')}
    />
  );
};

export default CampaignCreatedModal;
